import { Component, Input, OnDestroy, OnInit, Optional } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { AuthService } from '../../../core-services/authentication/auth.service';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { Subscription } from 'rxjs';
import { MatMenuModule } from '@angular/material/menu';
import { MatDividerModule } from '@angular/material/divider';
import { RouterModule } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { DeactivatePopupComponent } from '../../features/dependent-features/deactivate-popup/deactivate-popup.component';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [
    MatToolbarModule,
    MatButtonModule,
    MatIconModule,
    CommonModule,
    MatMenuModule,
    MatDividerModule,
    RouterModule,
  ],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
})
export class HeaderComponent implements OnInit, OnDestroy {
  @Input() role = '';
  userInitials = '';
  public showRegisterIcon = false;
  menus: string[] = [];

  private menuSub: Subscription | null = null;

  constructor(
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer,
    private router: Router,
    private authService: AuthService,
    @Optional() private dialog: MatDialog,
  ) {
    this.matIconRegistry.addSvgIcon(
      'accenture_logo',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/logo.svg'),
    );
  }

  ngOnInit(): void {
    if (this.authService.isUserAuthenticated()) {
      const enterpriseId = this.authService.getUserDetails().enterpriseId;
      this.userInitials = this.getInitials(enterpriseId);
      //console.log('ent id:' + this.getInitials(enterpriseId));
      this.menuSub?.unsubscribe();
      this.menuSub = this.authService.menu$.subscribe((menus) => {
        this.menus = menus;
      });
      //console.log('Menus in header:' + this.menus);
    }
  }

  onMenuClick(menuItem: string) {
    // Handle navigation or actions based on menu item
    // console.log('Clicked:', menuItem);
    if (menuItem === 'Nominate') {
      this.router.navigateByUrl('/registerDependent');
    } else if (menuItem === 'Update Nomination') {
      this.router.navigateByUrl('/dependentRegisterList');
    } else if (menuItem === 'Upload') {
      this.router.navigateByUrl('/uploadFile');
    } else if (menuItem === 'Deactivate') {
      this.dialog.open(DeactivatePopupComponent, {
        width: '700px', // 👈 Wider than default (default is 80vw)
        height: '500px', // 👈 Optional: for fixed height
        maxWidth: '90vw', // 👈 Prevents it from overflowing screen
        data: { message: 'Welcome to the Deactivate Popup!' },
      });
    } else if (menuItem === 'Logout') {
      // Clear storage optionally
      localStorage.clear();
      sessionStorage.clear();
      // Call async logout wrapper
      this.logout();
    }
  }

  async logout() {
    this.authService.logout();
  }

  getMenuIcon(item: string): string {
    switch (item.toLowerCase()) {
      case 'Nominate':
        return 'arrow_forward';
      case 'Update Nomination':
        return 'edit';
      case 'Deactivate':
        return 'edit';
      case 'Upload':
        return 'arrow_forward';
      default:
        return 'menu';
    }
  }

  ngOnDestroy(): void {
    this.menuSub?.unsubscribe();
  }

  getInitials(name: string): string {
    if (!name) {
      return 'NA'; // Or return a default like "NA"
    }

    const parts = name.trim().split('.');
    return parts.length > 1
      ? parts[0][0].toUpperCase() + parts[1][0].toUpperCase()
      : parts[0][0].toUpperCase();
  }
}
